const ISO_DATE_TIME_WITH_TIMEZONE_REGEX =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/;

const EXPORT_DATE_TIME_FORMATTER = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  month: "numeric",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit",
  hour12: true,
});

export function isIsoDateTimeString(value: string): boolean {
  return ISO_DATE_TIME_WITH_TIMEZONE_REGEX.test(value) && !Number.isNaN(Date.parse(value));
}

function getDateTimePart(
  parts: Intl.DateTimeFormatPart[],
  type: Intl.DateTimeFormatPartTypes
): string {
  return parts.find((part) => part.type === type)?.value ?? "";
}

export function formatExportDateTime(value: Date | string): string {
  const date = typeof value === "string" ? new Date(value) : value;
  const parts = EXPORT_DATE_TIME_FORMATTER.formatToParts(date);
  const month = getDateTimePart(parts, "month");
  const day = getDateTimePart(parts, "day");
  const year = getDateTimePart(parts, "year");
  const hour = getDateTimePart(parts, "hour");
  const minute = getDateTimePart(parts, "minute");
  const second = getDateTimePart(parts, "second");
  const dayPeriod = getDateTimePart(parts, "dayPeriod");

  return `${month}/${day}/${year} ${hour}:${minute}:${second} ${dayPeriod}`;
}

export const formatDateYearToMs = (date: Date): string => {
  // YYYYMMDDHHMMSSMS format
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const milliseconds = String(date.getMilliseconds()).padStart(3, "0").slice(0, 2);

  return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};
